module.exports = __webpack_public_path__ + "img/ftth_index05.d8f39e72.png";